<div class="carousel">
  <div class="carousel__container" #containerRef>
    <ng-template #itemsContainerRef />
  </div>

  @if (count > 1) {
    <div
      class="carousel__nav"
      [class.carousel__nav--hidden]="!isBrowser"
      (keyup.arrowRight)="next()"
      (keyup.arrowLeft)="prev()"
    >
      <button
        class="carousel__nav-btn carousel__nav-btn--left"
        paiIconButton="/assets/icons/chevron_right.svg"
        size="medium"
        type="button"
        [attr.aria-label]="'Carousel.ShowPrevItem' | translate"
        (click)="prev()"
      ></button>
      @for (item of data; track item; let i = $index) {
        <button
          class="carousel__nav-item"
          type="button"
          #navDot
          (click)="goTo(i)"
          paiRipple
          cdkMonitorElementFocus
          [attr.aria-label]="'Carousel.ShowItem' | translate: { ix: i + 1 }"
        >
          <span></span>
        </button>
      }
      <button
        class="carousel__nav-btn"
        paiIconButton="/assets/icons/chevron_right.svg"
        size="medium"
        type="button"
        [attr.aria-label]="'Carousel.ShowNextItem' | translate"
        (click)="next()"
      ></button>
    </div>
  }
</div>
